<template>
  <v-card class="helmi-card">
    <div class="helmi-card-title pl-6 pt-6">
      Muokkaa tietoja
    </div>
    <v-card-text>
      <v-text-field
        v-model="seller.nimi"
        class="mt-3 mb-1"
        type="text"
        outlined
        append-icon="person"
        label="Nimi"
      />
      <v-text-field
        id="seller-ssn"
        v-model="seller.sotu"
        class="mt-3 mb-1"
        type="text"
        outlined
        append-icon="verified_user"
        label="Henkilötunnus / y-tunnus"
      />
      <v-text-field
        v-model="seller.email"
        class="mt-3 mb-1"
        type="text"
        outlined
        append-icon="email"
        label="Sähkoposti"
      />
    </v-card-text>
    <v-card-actions>
      <v-spacer/>
      <v-btn
        color="primary"
        text
        @click="closeDialog()"
      >
        Peruuta
      </v-btn>
      <v-btn
        color="primary"
        text
        :loading="sending"
        @click="saveSellerDetails()"
      >
        Tallenna
      </v-btn>
    </v-card-actions>
  </v-card>
</template>
<script>
import { mapActions } from 'vuex';

export default {
  name: 'EditSeller',
  props: {
    seller: {
      type: Object,
      default: () => ({
        sotu: '',
        nimi: '',
        email: '',
      }),
    },
  },
  data: () => ({
    sending: false,
  }),
  methods: {
    ...mapActions({
      updateCustomer: 'updateCustomer',
    }),
    closeDialog() {
      this.$bus.$emit('closeSellerDialog');
    },
    async saveSellerDetails() {
      this.sending = true;
      await this.updateCustomer(this.seller);
      this.sending = false;
      this.$bus.$emit('reload');
      this.$bus.$emit('closeSellerDialog');
    },
  },
};
</script>
